import React from 'react';

import type { TravelCardProps } from './types';

import styles from './styles.module.scss';

export const TravelCard = (props: TravelCardProps): React.ReactElement => {
  const { icon, title, description } = props;

  return (
    <article className={styles.card}>
      <div className={styles.iconWrap} aria-hidden>
        {icon}
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </article>
  );
};
